var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ClicColInterno',{key:_vm.componentKey,attrs:{"cp":_vm.cp}},[_c('vue-file-toolbar-menu',{class:_vm.removeCard == true ? 'clicToolbar remove-card-toolbar' : 'clicToolbar',style:(_vm.style),attrs:{"content":_vm.contentTratado}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }